import { render, staticRenderFns } from "./bimManufacturerHints.vue?vue&type=template&id=1864643b&scoped=true&"
import script from "./bimManufacturerHints.vue?vue&type=script&lang=js&"
export * from "./bimManufacturerHints.vue?vue&type=script&lang=js&"
import style0 from "./bimManufacturerHints.vue?vue&type=style&index=0&id=1864643b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864643b",
  null
  
)

export default component.exports